import React from 'react'
import PropTypes from 'prop-types'
import Lottie from 'lottie-react'

import fileSizeLarge from '../assets/lottie/fileSizeLarge.json'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import SmallModal from '../components/Modals/SmallModal'

const FileTooLarge = ({ limit, open, onClose }) => (
  <SmallModal open={open} onClose={onClose}>
    <Stack gap={1} alignItems="center">
      <Lottie animationData={fileSizeLarge} loop={true} />
      <Typography variant="title3" textAlign="center">
        Sorry, this file is too large. Please upload a file smaller than {limit}
        MB.
      </Typography>
      <Button size="small" variant="contained" onClick={onClose}>
        Close
      </Button>
    </Stack>
  </SmallModal>
)

FileTooLarge.propTypes = {
  limit: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default FileTooLarge
